import {
  BrandAffinityLevel,
  useBrandAffinityTranslation,
  BRAND_AFFINITY_NAMES_TO_I18N_KEYS,
} from 'modules/domains/brandAffinity';
import { TabsGroup, TabsContent } from 'ui/tabsGroup';
import { useCoreContext } from 'modules/intelligentInsights/brandAffinityInsights/contexts/core/CoreContext';
import { AffinityContent } from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/AffinityContent';
import { AffinityContentSkeleton } from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/cohortTabContent/AffinityContentSkeleton';
import { affinityTabOrder } from 'modules/intelligentInsights/brandAffinityInsights/constants';
import {
  StyledAffinityBreakdownCard,
  StyledNavTabsList,
  StyledNavTabsTrigger,
} from 'modules/intelligentInsights/brandAffinityInsights/components/breakdownByAffinity/AffinityBreakdown.styles';

export const AffinityBreakdownTabs = () => {
  const { t } = useBrandAffinityTranslation();
  const { selectedAffinityTab, setSelectedAffinityTab, isReady } = useCoreContext();
  const onTabSelect = (tab: BrandAffinityLevel) => {
    setSelectedAffinityTab(tab);
  };

  return (
    <StyledAffinityBreakdownCard>
      <TabsGroup
        value={selectedAffinityTab}
        onValueChange={(newTab) => onTabSelect(newTab as BrandAffinityLevel)}
      >
        <StyledNavTabsList>
          {affinityTabOrder.map((affinity) => (
            <StyledNavTabsTrigger
              key={affinity}
              data-test={`${affinity}-affinity-tab-trigger`}
              value={affinity}
            >
              {t(BRAND_AFFINITY_NAMES_TO_I18N_KEYS[affinity])}
            </StyledNavTabsTrigger>
          ))}
        </StyledNavTabsList>
        {affinityTabOrder.map((affinity) => (
          <TabsContent key={affinity} value={affinity}>
            {!isReady ? <AffinityContentSkeleton /> : <AffinityContent affinityLevel={affinity} />}
          </TabsContent>
        ))}
      </TabsGroup>
    </StyledAffinityBreakdownCard>
  );
};
